import React from 'react';
import { cn } from '../../../utils/cn';

const Select = React.forwardRef(({ 
  variant = 'default',
  size = 'base',
  error = false,
  disabled = false,
  fullWidth = true,
  children,
  className,
  ...props 
}, ref) => {
  const variants = {
    default: 'border-gray-300 focus:border-primary-500 focus:ring-primary-500',
    error: 'border-red-300 focus:border-red-500 focus:ring-red-500'
  };

  const sizes = {
    sm: 'px-3 py-2 text-sm',
    base: 'px-4 py-3 text-base',
    lg: 'px-5 py-4 text-lg'
  };

  return (
    <select
      ref={ref}
      className={cn(
        // Base styles
        'border rounded-lg transition-all duration-200 bg-white',
        'focus:outline-none focus:ring-2 focus:ring-opacity-20',
        'appearance-none cursor-pointer',
        
        // Size styles
        sizes[size],
        
        // Variant styles
        error ? variants.error : variants.default,
        
        // State styles
        disabled && 'bg-gray-50 text-gray-500 cursor-not-allowed',
        fullWidth && 'w-full',
        
        // Custom className
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </select>
  );
});

Select.displayName = 'Select';

export default Select;